import { render, staticRenderFns } from "./Expertise.vue?vue&type=template&id=6f874264&scoped=true&"
import script from "./Expertise.vue?vue&type=script&lang=ts&"
export * from "./Expertise.vue?vue&type=script&lang=ts&"
import style0 from "./Expertise.vue?vue&type=style&index=0&id=6f874264&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f874264",
  null
  
)

export default component.exports